// extracted by mini-css-extract-plugin
module.exports = {"newsfeedCard":"ei-z"};